module.exports = __webpack_public_path__ + "img/bank1.34a780c7.png";